import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import GameMission from "./pages/GameMission";
import { ScrollToTop } from "./components/common/ScrollToTop";
// import GameMission2 from "./pages/GameMission2";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<GameMission />} />
            {/* <Route path="/" element={<GameMission2 />} /> */}
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
